export enum ProductGroupName {
  FIELD_INFO = 'field_info',
  SUGAR_CONTENT_PREDICTION = 'sat-sugarcontent',
  SUGAR_CONTENT_YIELD = 'sugaryield',
  VEGETATIVE_INDEX = 'vegetative-index'
}
